<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Component Imports
import Button from '@/common/Button.vue'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties
const isFilterActive = computed(() => {
    return !!viewStore.isFilterActive
})

// Methods
const toggleSearchToolbar = () => {
    viewStore.toggleSearchToolbar()
}
</script>

<template>
    <Button class="rounded-0" @click="toggleSearchToolbar" :active-class="'btn-warning'"
            :active-value="isFilterActive">
        <i class="bi-search"/>
    </Button>
</template>